module.exports = __webpack_public_path__ + "static/media/clients-template.b0d9d604.csv";